/**
 * Safe QA CSV/blob export download (P2-FE-014).
 * Rejects JSON error blobs that would otherwise save as .csv.
 */

export async function downloadQaExportBlob(
  response,
  { filename, expectedMime = 'text/csv' } = {}
) {
  const headers = response?.headers || {};
  const contentType = String(
    headers['content-type'] || headers['Content-Type'] || ''
  ).toLowerCase();
  const data = response?.data;

  const looksJsonType =
    contentType.includes('application/json') ||
    contentType.includes('text/json') ||
    (data instanceof Blob && String(data.type || '').includes('json'));

  if (looksJsonType) {
    const text =
      data instanceof Blob ? await data.text() : JSON.stringify(data || {});
    let message = 'Export failed';
    try {
      const parsed = JSON.parse(text);
      message = parsed.error || parsed.message || message;
    } catch (_err) {
      if (text) message = text.slice(0, 200);
    }
    const error = new Error(message);
    error.qaExportRejected = true;
    throw error;
  }

  // Some gateways return JSON with a generic octet-stream content-type.
  if (data instanceof Blob && data.size > 0 && data.size < 4096) {
    const probe = await data.slice(0, 1).text();
    if (probe === '{' || probe === '[') {
      const text = await data.text();
      let message = 'Export failed';
      try {
        const parsed = JSON.parse(text);
        message = parsed.error || parsed.message || message;
      } catch (_err) {
        message = text.slice(0, 200);
      }
      const error = new Error(message);
      error.qaExportRejected = true;
      throw error;
    }
  }

  const blob =
    data instanceof Blob
      ? data
      : new Blob([data], { type: `${expectedMime};charset=utf-8` });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || `qa-export-${Date.now()}.csv`;
  link.click();
  window.URL.revokeObjectURL(url);
  return true;
}
